import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ACTIONS, DialogData, DialogResult } from 'src/app/global/models/dialog/dialog-data';

@Component({
  selector: 'app-dialog-rounded',
  templateUrl: './dialog-rounded.component.html',
  styleUrls: ['./dialog-rounded.component.scss']
})
export class DialogRoundedComponent {


  constructor(
    public dialogRef: MatDialogRef<DialogRoundedComponent, DialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    console.log(this.data);
  }

  onActionClick(): void {
    this.dialogRef.close({
      action: ACTIONS.OK
    });
  }

  onCloseClick(): void {
    this.dialogRef.close({
      action: ACTIONS.CANCEL
    });
  }
}
